import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px;
`;

export const Header = styled.div<{ $isCentered?: boolean }>`
  position: relative;
  height: 97px;
  display: flex;
  align-items: center;
  justify-content: ${({ $isCentered }) =>
    $isCentered ? 'center' : 'space-between'};
`;

export const Title = styled(Typography.Header).attrs(() => ({
  $variant: '3',
}))`
  font-size: 22px;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  width: 20px;
  height: 20px;
  border: none;
  outline: none;
  cursor: pointer;
  box-shadow: none;
  background: none;
  transform: translateY(-50%);
`;

export const StickySection = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const Section = styled.div`
  display: flex;
  height: 45px;
  margin: 10px 0 0 0;
  align-items: center;
  justify-content: space-between;
`;

export const SectionTitle = styled(Typography.Header).attrs(() => ({
  $variant: '3',
}))`
  user-select: none;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const CreateLink = styled.button`
  outline: none;
  border: none;
  cursor: pointer;
  background: none;
  box-shadow: none;
  font-size: 16px;
  font-weight: 500;
  user-select: none;
  font-family: 'Helvetica Neue', sans-serif;
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const Footer = styled.div`
  display: flex;
  padding: 0;
  height: 94px;
  align-items: center;
  justify-content: space-between;
`;
